declare global {
  interface Window {
    ASSET_HOST?: string
    /** Set in application layout from ApplicationHelper#app_version_display */
    APP_VERSION?: string | null
  }
}

/**
 * Returns the full URL for a static asset path. In production with ASSET_HOST
 * set, this prefixes the path with the S3/CDN base URL; otherwise returns
 * the path for same-origin serving.
 */
export function assetUrl(path: string): string {
  const base = typeof window !== "undefined" ? (window.ASSET_HOST ?? "") : ""
  const normalizedPath = path.startsWith("/") ? path : `/${path}`
  return `${base}${normalizedPath}`
}

/**
 * Same-origin URL for html2canvas share capture. When ASSET_HOST is set,
 * routes through /share-assets so images load without S3 CORS.
 */
export function shareCaptureAssetUrl(path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`
  if (normalizedPath.startsWith("/share-assets/")) return normalizedPath
  // Always proxy static assets through same-origin /share-assets for html2canvas capture.
  return `/share-assets${normalizedPath}`
}
